export default function affiliateSelect($stateParams, $state, $rootScope, API, UserCache) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      affiliates: '=affiliates',
    },
    template: '<input type="hidden" class="bigdrop" id="affiliate" style="width:100%;"/>',
    link: selectLink,
  }

  return directive

  function selectLink($scope, $element, $attr) {
    var auth = UserCache.getObject()
    $.ajaxSetup({
      headers: {
        'X-Collectible-Platform': 'QP2',
        Authorization: 'Bearer ' + auth.jwt,
      },
    })
    $('#affiliate').select2({
      ajax: {
        url: function(t, page) {
          var start, limit
          if (page === 1) {
            start = 0
            limit = 25
          } else {
            limit = page * 25
            start = limit - 25
          }
          return API.API_URL + 'admin/affiliates/search?start=' + start + '&limit=' + limit
        },
        dataType: 'json',
        quietMillis: 250,
        data: function(t, page) {
          return {
            page: page,
            t: t,
          }
        },
        results: function(data, page) {
          $rootScope.$broadcast('affiliateList', data.results)
          return {
            results: data.results,
            more: page + 25 < data.ct,
          }
        },
      },
      multiple: true,
      escapeMarkup: function(markup) {
        return markup
      }, // let our custom formatter work
      minimumInputLength: 2,
      formatResult: formatState,
      formatSelection: formatStateSelection,
    })

    function formatState(state) {
      if (state.loading) {
        return state.text
      }

      var markup =
        "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" +
        state.fn +
        ' ' +
        state.ln +
        '</div>'
      ;('</div></div>')

      return markup
    }

    function formatStateSelection(state) {
      return state.fn + ' ' + state.ln
    }
  }
}
